import React, { useContext } from 'react';
import NavbarKey from '../components/nav/NavBarKey'
import UserProvider from '../context/UserContext';
import MainKey from '../components/mains/MainKey';
import _ from "lodash";
import AlertTemplate from "react-alert-template-basic";
import { positions, transitions, Provider } from "react-alert";
import NavBarDash from '../components/nav/NavBarDash';
import MainDash from '../components/mains/MainDash';

const options = {
    timeout: 1500,
    position: positions.BOTTOM_CENTER,
    offset: '30px',
    transitions: transitions.FADE,
    containerStyle: {
        zIndex: 300,
    }
};

const Dash = () => {
    const Data = useContext(UserProvider.context);
    const userData = Data.user
    const memberData = Data.member
    const Logged = !_.isEmpty(userData);
    const isLoading = !(Data.loading);
    const isMember = !_.isEmpty(memberData);
    

    return (
        <div className="parent">
            {
                isLoading && 
                Logged &&
                isMember &&
                <Provider template={AlertTemplate} {...options}>
                <div id="overlay" className="overlay">
                    <div className="opacity">
                    </div>
                </div>
                <div>
                    <NavBarDash></NavBarDash>
                </div>
                <div className="column-main">
                    <MainDash/>
                </div>
                </Provider>
            }
            {
                isLoading && 
                Logged &&
                !isMember &&
                <Provider template={AlertTemplate} {...options}>
                <div>
                    <NavbarKey></NavbarKey>
                </div>
                <div className="column-main container">
                    <MainKey/>
                </div>
                </Provider>
            }
            {
                isLoading && 
                !Logged &&
                window.location.replace(`${process.env.REACT_APP_API_URL}/discord-auth/`)
            }
        </div>
    )
};


export default Dash;
